import React, { Component } from 'react';
import './App.css';
import web3 from "./web3";
import lott from './lott';
import spunge from './spunge';
import { Button } from 'semantic-ui-react';
import 'semantic-ui-css/semantic.min.css';
import spungeLogo from './spunge_logo_tspnt.png';

class App extends Component {
  state = {
    manager: '',
    playersAmt: '',
    balance: '',
    value: '',
    playerEntries: '',
    ticketCost: ''
  };
  
  async componentDidMount() {
    const accounts = await web3.eth.getAccounts();
    const manager = await lott.methods.getOwner().call();
    const playersAmt = await lott.methods.getPlayersAmt().call();
    const balance = await lott.methods.getPrizePool().call() / 1000000000;
    const playerEntries = await lott.methods.myEntries(accounts[0]).call();
    // FIX THIS BEFORE DEPLOY - change to 9 deci not 18
    const ticketCost = await lott.methods.ticketPrice.call()  ;

    this.setState({ manager, playersAmt, balance, playerEntries, ticketCost });
  }


onSubmit = async (event) => {
  event.preventDefault();

  const accounts = await web3.eth.getAccounts();
    await lott.methods.addEntry(this.state.value).send({
      from: accounts[0]
    });
  }

  onApprove = async (event) => {
    event.preventDefault();

    console.log("hello?!?")
    console.log("allowance")

    const accounts = await web3.eth.getAccounts();
    var amount = 10000000000000;
    var approveAmt = web3.utils.toWei(amount.toString(), 'ether');

    await spunge.methods.approve(lott.options.address,approveAmt).send({
      from: accounts[0]
    }); 
}

render() {
  // document.body.style.backgroundColor = 'linear-gradient(red, yellow)';
  document.body.style.backgroundColor = '#2d0076'
  return (       
    <div className="container">
      <br/>
      <center>
        <img className='spunge-logo' src={spungeLogo} alt=""/>
        <p className='logo-footer'>SPUNGE.SPACE</p>
      </center>
      <br/>
      <center>
        <h1 className='heading'>TOKEN LOTTERY</h1>
      </center>
      <br/>
      <br/>
      <center>
        <span className='prize-pool-value'>  
          {this.state.balance} SPUNGE
        </span>
        <span className='prize-pool'>  
          Prize Pool!
        </span>
      </center>
      <br/>
      <br/>
      <div className='input_container'>
        <center>
          <h2>Enter for a chance to win!</h2>
        </center>
        <br/>
        <center>
          <span className='amount-remaining'> 
            {this.state.playersAmt}
          </span>
          <span> 
            Total entries. 
          </span>
        </center>
        <br/>
        <center>
          <span className='amount-remaining'> 
            2,500 SPUNGE
          </span>
          <span> 
            per ticket. 
          </span>
        </center>

        <br/>
        <center>
          <form onSubmit={this.onApprove}>
            <Button content="Approve SPUNGE" primary/>
          </form> 
        </center>
        <br/>
        <center>
          <p> 
            Your entries: {this.state.playerEntries} 
          </p>
        </center>
        <center><form onSubmit={this.onSubmit}>  
          <br/>
          <h4> Amount of tickets to buy </h4>

          <br/>
          <input
            value={this.state.value}
            onChange={event => this.setState({ value: event.target.value })}
          />
          <br/>
          <br/>
          <Button
          content="Enter"
          primary/> 
        </form></center>
      </div>
      <br/>
      <center>
        <footer className='footer'>Hosted by <a href="https://spunge.space">spunge.space</a></footer>
      </center>
    </div>
    );
  }
}
export default App;
